import { Field } from '@campfire/field';
import { TabletButton } from '@campfire/tablet-button';
import { Form, Formik } from 'formik';
import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router';
import { object as YupObject, string as YupString } from 'yup';
import { CreateTrialAccountFormValues } from '../CreateTrialAccountTypes';
import { TRIAL_STEPS, TrialStepsEnum } from '../CreateTrialAccountConsts';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';
import { StepHeader } from './Stepheader';

const YourDetailStepSchema = YupObject().shape({
  firstName: YupString().required('Please enter your first name'),
  lastName: YupString().required('Please enter your last name'),
  email: YupString()
    .required('Please enter your email')
    .email('Please enter a valid email'),
  contactNumber: YupString(),
});

export const YourDetailStep = ({
  trialData,
  next,
}: {
  trialData: CreateTrialAccountFormValues;
  next: (newData: CreateTrialAccountFormValues, step: string) => void;
}) => {
  const {
    YOUR_DETAIL: { step, title, subtitle },
  } = TRIAL_STEPS;
  const { theme, isMobile } = useCampfireTheme();
  const history = useHistory();

  const handleSubmit = (values: CreateTrialAccountFormValues) => {
    next(values, TrialStepsEnum.ORG_DETAIL);
  };

  return (
    <Formik initialValues={trialData} validationSchema={YourDetailStepSchema} validateOnBlur onSubmit={handleSubmit}>
      <Form>
        <Box mx={isMobile ? '24px' : '34px'} my='28px'>
          <StepHeader step={step} title={title} subtitle={subtitle} />
          <Grid container spacing={3} style={{ marginTop: '16px' }}>
            <Grid item container sm={12} spacing={4}>
              <Grid item xs={12} sm={6}>
                <Field shrink required fullWidth name='firstName' label='First Name' variant='outlined' />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field shrink required fullWidth name='lastName' label='Last Name' variant='outlined' />
              </Grid>
            </Grid>
            <Grid item container sm={12} spacing={4}>
              <Grid item xs={12} sm={6}>
                <Field
                  shrink
                  required
                  fullWidth
                  variant='outlined'
                  type='email'
                  name='email'
                  label='Email Address'
                  placeholder='example@example.com'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field shrink fullWidth variant='outlined' name='contactNumber' label='Mobile Number' />
              </Grid>
            </Grid>
          </Grid>
          <Box display='flex' justifyContent='flex-end' pt='28px'>
            <TabletButton
              size='medium'
              style={{
                backgroundColor: theme.color.grey.neutral200,
                color: '#ffffff',
                boxSizing: 'border-box',
                borderRadius: '4px',
                textTransform: 'none',
                padding: '7px 12px',
                fontWeight: 600,
                fontSize: '13px',
                marginRight: '8px',
              }}
              onClick={() => history.push(`/`)}
            >
              Back
            </TabletButton>
            <TabletButton
              size='medium'
              variant='text'
              type='submit'
              style={{
                backgroundColor: theme.color.secondary.main900,
                color: '#ffffff',
                boxSizing: 'border-box',
                borderRadius: '4px',
                textTransform: 'none',
                padding: '7px 12px',
                fontWeight: 600,
                fontSize: '13px',
              }}
            >
              Next
            </TabletButton>
          </Box>
        </Box>
      </Form>
    </Formik>
  );
};
